<div
  class="datepicker-trigger"
  [class.open]="isOpen"
  [class.disabled]="isDisabled"
  (click)="toggleDropdown()"
>
  <span
    class="datepicker-trigger__label"
    [class.datepicker-trigger__label--placeholder]="!value"
  >
    {{ value ? formatDate(value) : placeholder }}
  </span>
  <button
    *ngIf="value && !isDisabled"
    type="button"
    class="datepicker-trigger__clear"
    (click)="clear(); $event.stopPropagation()"
  >
    <i class="icon--close icon--sm"></i>
  </button>
  <i class="icon--calendar icon--md datepicker-trigger__icon"></i>
</div>

<div class="datepicker-dropdown" *ngIf="isOpen" [ngStyle]="dropdownStyle" (click)="$event.stopPropagation()">
  <app-calendar-panel
    [viewYear]="viewYear"
    [viewMonth]="viewMonth"
    [selectedDate]="value"
    [min]="min"
    [max]="max"
    (dateSelect)="onDateSelect($event)"
    (viewMonthChange)="onViewMonthChange($event)"
    (viewYearChange)="onViewYearChange($event)"
  ></app-calendar-panel>
</div>
